import { CLEAR_TOKEN, SET_QR_CODE, SET_TOKEN, SET_USER_MENUS } from "../types";

interface AuthState {
  token: string | null;
  userId: string | null;
  qr: string | null;
  menus: any
}

const initialState: AuthState = {
  token: null,
  userId: null,
  qr: null,
  menus: null
};


const authReducer = (state = initialState, action: { type: string; token: string | null; userId: string | null; qr: string | null, menus: any }) => {
  
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        token: action.token,
        userId: action.userId
      };
    case CLEAR_TOKEN:
      return initialState;
    case SET_QR_CODE:
      return {
        ...state,
        qr: action.qr
      }
    case SET_USER_MENUS:
      return {
        ...state,
        menus: action.menus
      }
    default:
      return state;
  }
};

export default authReducer;